import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20background%20with%20soft%20gradient%20waves%20in%20warm%20coral%20and%20cream%20tones%2C%20clean%20digital%20atmosphere%2C%20smooth%20flowing%20lines%2C%20tech%20inspired%20design%20with%20subtle%20grid%20patterns%2C%20bright%20airy%20feel%2C%20professional%20yet%20friendly%20aesthetic&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="jm下载指南背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto pt-16">
        <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 rounded-full text-sm font-medium mb-6">
          jm下载 - 官方安全下载指南
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-5xl font-bold text-background-50 mb-5 leading-tight">
          安全、快速、便捷的
          <br />
          <strong className="text-primary-300">jm下载</strong>完整指南
        </h1>
        <p className="text-background-50/80 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          提供最新版本的jm下载方法、步骤详解及常见问题解答，帮助您快速、安全地完成jm下载。
          解决下载失败、速度慢等常见问题，是您jm下载的权威参考页面。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/xiazai-zhinan"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始jm下载指南
          </Link>
          <Link
            to="/category/changjian-wenti"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看常见问题
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-background-50/70 text-xs">
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-sm text-accent-400"></i>
            </span>
            <span>官方安全渠道</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-speed-up-line text-sm text-accent-400"></i>
            </span>
            <span>高速下载体验</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-guide-line text-sm text-accent-400"></i>
            </span>
            <span>详细步骤教程</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-sm text-accent-400"></i>
            </span>
            <span>专业技术支持</span>
          </div>
        </div>
      </div>
    </section>
  );
}